import { useState } from "react";

export default function ToPayPartial({
  order,
  setSingleOrderToPay,
  handelPaymentModal,
  formatToMMDDYYYY,
  selectedOrders,
  handleSelectOrder,
  handelCancelModal, // 👈 add this
}) {
  const [isCancelled, setIsCancelled] = useState(false);
  return (
    <>
      {" "}
      <div key={order.COI_ID} className="dp-item-wrapper">
        {/* Header Row */}
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            checked={selectedOrders.includes(order.COI_ID)}
            onChange={() => handleSelectOrder(order.COI_ID)}
          />
        </div>
        <div className="grid-image-wrapper">
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${order.PD_ID}/${order.PD_ProductPicPath[0]}`}
            alt={order.PD_Name}
          />
        </div>
        <div className="grid-order-details-wrapper">
          <div className="ord-prod-name">
            <span className="name">{order.PD_Name}</span>
            <span className="qty">x{order.COI_Quantity}</span>
          </div>
          <span>DATE ORDERED : {formatToMMDDYYYY(order.COI_Created_At)}</span>
          <span>ORDER NUMBER : {order.COI_Number}</span>
          <span>ORDER TYPE : {order.PD_ProductType}</span>
        </div>
        <div className="grid-order-status-wrapper">
          {" "}
          <span className="ord-prod-status" style={{ color: `#E2B808` }}>
            TO PAY
          </span>
          <span>TOTAL AMOUNT : {order.COI_TotalAmount}</span>
          <span>DOWNPAYMENT : {order.COI_DP}</span>
        </div>
        <div className="grid-message-wrapper">
          <span style={{ color: `#E2B808` }}>AWAITING PAYMENT</span>
        </div>

        <div className="grid-payment-wrapper">
          <span className="m-message">
            AMOUNT PAID : {order.COI_Downpayment}
          </span>
          <span className="m-message">BALANCE : {order.COI_Balance}</span>
          <div className="buttons-wrapper">
            <button
              className="cancel-btn"
              onClick={() => {
                setSingleOrderToPay(order); // 👈 set the single order
                handelCancelModal(); // 👈 call cancel
              }}
            >
              CANCEL ORDER
            </button>
            <button
              className="pay-btn"
              onClick={() => {
                setSingleOrderToPay(order); // ✅ pass only this order
                handelPaymentModal();
              }}
            >
              PAY
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
